export default "__VITE_ASSET__Cq7dLilX__"